module.exports = __webpack_public_path__ + "f0366b2774aee446c62c95842bf2cdaa.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/giraffe.svg
// module id = 88
// module chunks = 0